var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.logoClasses},[_c('img',{staticClass:"logo__image",attrs:{"src":_vm.logoSrc,"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }